import { useMemo } from "react";
import { PSelect, Select } from "./Select";

type PMerchantsSelect<T extends object> = {
  listOfValues: T[];
  value: PSelect["value"];
  onChange: PSelect["onChange"];
  label: string;
  color: string;
  baseColor: string;
  borderColor: string;
  expandedBorderColor?: string;
  enableSearch?: boolean;
  currentId?: number;
  searchableValues?: any;
  onExpandedChange?: (expanded: boolean) => void;
};

interface IBaseMerchant {
  id: number;
  name: string;
}

export const MerchantDropdown = <T extends IBaseMerchant>(
  props: PMerchantsSelect<T> & { expanded?: boolean }
) => {
  const {
    listOfValues,
    value,
    onExpandedChange,
    onChange,
    label,
    color,
    baseColor,
    borderColor,
    expandedBorderColor,
    enableSearch = false,
    currentId,
    searchableValues,
    expanded,
  } = props;

  const options = useMemo(() => {
    return listOfValues.map((item) => ({
      label: (
        <div className="flex flex-row justify-between w-full">
          <div className="flex items-center gap-[10px]">
            <span className={`text-[12px]`}>{item.name}</span>
          </div>
        </div>
      ),
      value: item.id,
    }));
  }, [listOfValues]);

  return (
    <Select
      label={label}
      options={options}
      value={value}
      color={color}
      borderColor={borderColor}
      baseColor={baseColor}
      expandedBorderColor={expandedBorderColor}
      expanded={expanded}
      onChange={(val: any) => onChange && onChange(val)}
      getOptionCls={(isActive: any) =>
        isActive
          ? "text-text-navbar-active text-[12px]"
          : "text-text-base text-[12px]"
      }
      enableSearch={enableSearch}
      searchableLabels={searchableValues}
      optionsHeader={
        <div className="w-full flex flex-row justify-between text-grayscale-4 text-[12px] cursor-default"></div>
      }
    />
  );
};
